/**
 * 错误分类工具：区分「网络/超时错误」「后端未实现(404)」「业务错误」。
 *
 * 背景（安全止血 H2）：
 *   - http.ts 在 fetch 失败时抛 ApiError(0, '网络异常')；
 *   - 后端未实现接口时，Gin 对无路由请求返回纯文本 404，http.ts 解析 JSON 失败后
 *     抛 ApiError(404, '请求失败（HTTP 404）', 404)，即 code === status === 404；
 *   - 后端业务校验失败时返回 JSON envelope { code, message }，http.ts 抛
 *     ApiError(code, message, status)，如 4001/4002/4005/4006（HTTP 400）、
 *     1004 订单不存在（HTTP 404）、2001 未授权（HTTP 401）。
 *
 * 降级规则：仅「网络错误」或「后端未实现(纯文本 404)」允许降级 mock，
 * 业务错误一律透传，由页面展示真实失败原因，绝不静默返回 mock 假成功。
 */
import { ApiError } from './http';

/** 网络/超时错误（后端不可达、断网、CORS），允许降级 mock */
export function isNetworkError(e: unknown): boolean {
  return e instanceof ApiError && e.code === 0;
}

/**
 * 后端未实现：HTTP 404 且响应体非 JSON envelope（code 被 http.ts 置为 status）。
 * 与「业务 404」（如订单不存在 code=1004、status=404）区分，后者 code !== status。
 */
export function isUnimplementedError(e: unknown): boolean {
  return e instanceof ApiError && e.status === 404 && e.code === 404;
}

/** 是否允许安全降级 mock：仅网络错误 / 后端未实现 */
export function canFallbackToMock(e: unknown): boolean {
  return isNetworkError(e) || isUnimplementedError(e);
}
